/**
 * Uploaded profile and branding images (avatars, organization and project logos).
 *
 * Images are stored as small square files under random names and served by the
 * API at stable URLs (`/images/<key>`) that redirect to a short-lived signed
 * URL. Only keys matching IMAGE_KEY are ever served through that route.
 */
export const IMAGE_URL_PREFIX = '/images/';
export const IMAGE_MAX_BYTES = 2 * 1024 * 1024;
export const AVATAR_SIZE = 256;
export const LOGO_SIZE = 512;

export const imageKeys = {
  avatar: (userId: string, id: string) => `users/${userId}/avatar-${id}.webp`,
  orgLogo: (orgId: string, id: string) => `orgs/${orgId}/branding/logo-${id}.webp`,
  projectLogo: (orgId: string, projectId: string, id: string) => `orgs/${orgId}/projects/${projectId}/logo-${id}.webp`,
};

const IMAGE_KEY =
  /^(users\/[A-Za-z0-9_-]+\/avatar-[A-Za-z0-9_-]+|orgs\/[A-Za-z0-9_-]+\/branding\/logo-[A-Za-z0-9_-]+|orgs\/[A-Za-z0-9_-]+\/projects\/[A-Za-z0-9_-]+\/logo-[A-Za-z0-9_-]+)\.(webp|png|jpg)$/;

export function isImageKey(key: string): boolean {
  return IMAGE_KEY.test(key);
}

export function imageUrl(key: string): string {
  return IMAGE_URL_PREFIX + key;
}

/** The storage key behind one of our image URLs, or null for anything else (e.g. a Google avatar). */
export function imageKeyFromUrl(url: string): string | null {
  if (!url.startsWith(IMAGE_URL_PREFIX)) return null;
  const key = url.slice(IMAGE_URL_PREFIX.length);
  return isImageKey(key) ? key : null;
}
